module.exports = __webpack_public_path__ + "img/core.348e136a.png";